const configured = (import.meta.env.VITE_STORE_API_URL as string | undefined)?.replace(/\/$/, "");
const base = import.meta.env.DEV ? "/local-affiliates" : configured;

export interface TrackedOrder {
  number: string;
  created_at: string | null;
  total: string | null;
  subtotal: string | null;
  shipping_cost: string | null;
  currency: string | null;
  destination: string | null;
  products: { name: string; quantity: number | string | null; price: string | null; compare_at_price: string | null; image: string | null }[];
  status: { label: string; headline: string; at: string | null };
  events: { label: string; at: string | null }[];
  fulfillment: Shipment | null;
  fulfillments?: Shipment[];
}

export interface Shipment {
  carrier: string | null;
  tracking_code: string | null;
  tracking_url: string | null;
  correios?: boolean;
}

export async function lookupOrdersByDocument(document: string): Promise<TrackedOrder[]> {
  if (!base) throw new Error("A consulta de pedidos ainda não está disponível.");

  const response = await fetch(`${base}/order-lookup.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ document }),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok || !Array.isArray(data?.orders)) {
    throw new Error(data?.message || "Não foi possível consultar seus pedidos.");
  }
  return data.orders as TrackedOrder[];
}
